// @ts-ignore
/* eslint-disable */
import axios from 'axios';
import { request } from '../axios/gateway';

/** 这是一个特殊的服务，是网关直接暴露的接口，没有 swagger 文档，所以所有代码是手写的，不是自动生成 */

/** 登录用户信息 user/info */
export async function userInfo(
  params: {},
  options?: { [key: string]: any },
) {
  return request<APIGateway.UserInfoResponse>('/user/info', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}


/** 用户权限 user/permissions */
export async function userPermissions(
  params?: {},
  options?: { [key: string]: any },
) {
  return request<APIGateway.UserInfoResponse>('/user/permissions', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}


/** 退出登录  */
export async function loginOut() {
  return request('/logout', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export async function logon(params: {
  accessToken: string,
  appId: string
  deviceId: string
}) {
  return request('/logon', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    params
  });
}



/** 克隆登录接口 mchgateway/sdppro/login/clone */
export async function cloneLogin() {
  return request('/sdppro/login/clone', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
}


// 更换token接口
export function ChangeLoginToken(params: {
  accessToken: string
  deviceId: string
}) {
  return axios.post('/sdppro/api/login/token/change', params).then(res => res?.data)
}
